// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gibd","colBig":"styles_colBig__Ek57H","colSmall":"styles_colSmall__1NqXp"};